import React from "react";
import styled from "styled-components";
import Link from "gatsby-link";
import Img from "gatsby-image";
import Button from "./Button";

const Container = styled.div`
  display: flex;
  align-items: ${props => (props.inverted ? "center" : "flex-start")};
  justify-content: ${props => (props.inverted ? "flex-end" : "flex-start")};
  position: relative;
  min-height: ${props => (props.minHeight ? "48em" : "auto")};
  margin: ${props => (props.inSmallHeader ? "0 0 1em 0" : "6em 0")};
  
  @media (max-width: 559px) {
    margin: ${props => (props.smallMargin ? "0 0 16px 0" : (props.inSmallHeader ? "0" : "6em 0"))}
  }  

  flex-direction: column-reverse;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex-direction: row;
    padding: ${props => (props.inSmallHeader ? "0 6em" : "0")};
  }

  // > div {
  //   height: 100%;
  //   // padding-bottom: 60%;
  //   width: 100%;
  //   max-width: 20%;
  // }
`;

const TextContainer = styled.div`
  width: 100%;

  p {
    border-left: 6px solid ${props => props.theme.colors.secondary};
    padding-left: 2rem;
    line-height: 1.5;
    color: ${props =>
      props.diapositive
        ? props.theme.colors.tertiary
        : props.theme.colors.base};
    margin-bottom: 2rem;

    > p {
      border-left: none;
      padding-left: 0;
      max-width: none;
    }
  }
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    max-width: ${props => (props.fullWidth ? "100%" : "calc(100% - 22em)")};
    width: 100%;

    p {
      max-width: ${props => (props.fullWidth ? "calc(100% - 22em)" : "100%")};
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    max-width: ${props => (props.fullWidth ? "100%" : "32em")};
    width: 100%;

    p {
      max-width: ${props => (props.fullWidth ? "32em" : "100%")};
    }
  }
`;

const ImageWrapper = styled.figure`
  box-shadow: -6px 8px 25px 0 rgba(0, 0, 0, 0.5);
  z-index: 1;
  width: 100%;
  position: relative;
  margin-bottom: 1.5em;

  img {
    object-fit: ${props => props.fit || "cover"} !important;
    object-position: ${props => props.position || "50% 50%"} !important;
    font-family: 'object-fit: ${props =>
      props.fit || "cover"} !important; object-position: ${props =>
  props.position || "50% 50%"} !important;'
  }
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    max-width: 20em;
    height: 100%;
    position: absolute;
    right: ${props => (props.inverted ? "auto" : "0")};
    left: ${props => (props.inverted ? "0" : "auto")};
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    height: 100%;
    position: absolute;
    top: 0;
    right: ${props => (props.inverted ? "auto" : "0")};
    left: ${props => (props.inverted ? "0" : "auto")};
    width: 20em;
    margin-bottom: 0;
    // transform: translateX(50%);
    transform: ${props =>
      props.inverted ? "translateX(-50%)" : "translateX(50%)"};
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${props => props.theme.colors.secondary};
    mix-blend-mode: multiply;
    opacity: 0;

    @supports (mix-blend-mode: multiply) {
      opacity: 1;
    }
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${props => props.theme.colors.black};
    mix-blend-mode: screen;
    opacity: 0.5;
    z-index: 1;

    @supports (mix-blend-mode: multiply) {
      opacity: 1;
    }
  }

  div {
    height: 100%;
  }
`;

const Title = styled.h2`
  font-size: 2.125rem;
  @media (min-width: ${props => props.theme.responsive.small}) {
    font-size: 3.125rem;
  }
  // font-weight: 600;
  text-transform: capitalize;
  margin: 0 1rem 2.8rem 0;
  line-height: normal;
  color: ${props =>
    props.diapositive ? props.theme.colors.tertiary : props.theme.colors.base};
`;

const MainTitle = styled.h1`
  font-size: ${props => (props.inSmallHeader ? "26px" : "1.875rem")};
  @media (min-width: ${props => props.theme.responsive.small}) {
    font-size: ${props => (props.inSmallHeader ? "3.125rem" : "3.75rem")};
  }
  // font-weight: 600;
  text-transform: capitalize;
  margin: ${props => (props.inSmallHeader ? "0 0 1rem 0" : "0 1rem 2rem 0")};
  line-height: normal;
  color: ${props =>
    props.diapositive ? props.theme.colors.tertiary : props.theme.colors.base};
`;

const TextBlock = styled.div``;

const ButtonLink = styled.a`
  border-top: 1px solid ${props => props.theme.colors.secondary};
  border-right: 1px solid ${props => props.theme.colors.secondary};
  border-bottom: 4px solid ${props => props.theme.colors.secondary};
  border-left: 4px solid ${props => props.theme.colors.secondary};
  appearance: none;
  padding: 0.8rem 2.25rem;
  background-color: transparent;
  color: ${props => (props.diapositive ? "white" : props.theme.colors.base)};
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.2s;
  text-decoration: none;
  display: inline-block;

  &:hover {
    background-color: ${props => props.theme.colors.secondary};
    color: ${props =>
  props.diapositive ? props.theme.colors.base : "inherit"};
  }
`;

const ContentBlock = props => {
  return (
    <Container smallMargin={props.smallMargin} inSmallHeader={props.inSmallHeader} inverted={props.inverted} minHeight={props.image}>
      <TextContainer
        fullWidth={props.fullWidth}
        diapositive={props.diapositive}
      >
        {props.largeTitle ? (
          <MainTitle inSmallHeader={props.inSmallHeader} diapositive={props.diapositive}>{props.title}</MainTitle>
        ) : (
          <Title diapositive={props.diapositive}>{props.title}</Title>
        )}

        {props.body &&
          <TextBlock
            diapositive={props.diapositive}
            dangerouslySetInnerHTML={{
              __html: props.body.childMarkdownRemark.html
            }}
          />
        }

        {props.onButtonClick ? (
          <Button
            onButtonClick={props.onButtonClick}
            src={props.src}
            diapositive={props.diapositive}
            title={props.buttonText}
          />
        ) : null }

        {!props.onButtonClick && props.buttonText ? (
          <ButtonLink href={props.src} diapositive={props.diapositive}>{props.buttonText}</ButtonLink>
        ) : null}

      </TextContainer>
      {props.image ? (
        <ImageWrapper inverted={props.inverted}>
          <Img sizes={props.image.sizes} backgroundColor={"#eeeeee"} />
        </ImageWrapper>
      ) : null}
    </Container>
  );
};

export default ContentBlock;



// WEBPACK FOOTER //
// ./src/components/ContentBlock.js